import { render, staticRenderFns } from "./IbToggleButton.vue?vue&type=template&id=2f1c9408&scoped=true"
import script from "./IbToggleButton.vue?vue&type=script&lang=js"
export * from "./IbToggleButton.vue?vue&type=script&lang=js"
import style0 from "./IbToggleButton.vue?vue&type=style&index=0&id=2f1c9408&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1c9408",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f1c9408')) {
      api.createRecord('2f1c9408', component.options)
    } else {
      api.reload('2f1c9408', component.options)
    }
    module.hot.accept("./IbToggleButton.vue?vue&type=template&id=2f1c9408&scoped=true", function () {
      api.rerender('2f1c9408', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_v2/Button/IbToggleButton.vue"
export default component.exports